export default __webpack_public_path__ + "static/media/portfolio-react.02517714.png";